import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
import { Subject, take, takeUntil } from 'rxjs';
import Swal from 'sweetalert2';
import { MatStrokedButtonBorderDirective } from '../../directives';
import { CartBillService } from '../../services';

@Component({
    standalone: true,
    selector: 'app-cancel-payment',
    templateUrl: './cancel-payment.component.html',
    styleUrls: ['./cancel-payment.component.scss'],
    imports: [MatIconModule, MatButtonModule, MatStrokedButtonBorderDirective],
})
export class CancelPaymentComponent implements OnInit, OnDestroy {
    private unsubscribe$: Subject<void>;
    public isEmptyCart = true;

    constructor(
        private router: Router,
        private cartBillService: CartBillService
    ) {
        this.unsubscribe$ = new Subject<void>();
    }

    ngOnInit(): void {
        this.subscribeCart();
    }

    ngOnDestroy(): void {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

    subscribeCart(): void {
        this.cartBillService
            .isEmptyCart$()
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe((emptyCart) => {
                this.isEmptyCart = emptyCart;
            });
    }

    calcelPayment(): void {
        if (this.isEmptyCart) {
            this.router.navigate(['/search-awb']);
            return;
        }

        this.showModal();
    }

    showModal(): void {
        Swal.fire({
            title: 'Warning!',
            text: `Your Payment will be canceled. Are you sure?`,
            icon: 'warning',
            cancelButtonText: 'CLOSE',
            denyButtonText: 'CANCEL PAYMENT',
            showConfirmButton: false,
            showCancelButton: true,
            showDenyButton: true,
            showCloseButton: true,
            customClass: {
                cancelButton: 'order-1',
                denyButton: 'order-2',
            },
        }).then((result) => {
            if (result.isDenied) {
                this.deleteCart();
            }
        });
    }

    deleteCart(): void {
        this.cartBillService
            .deleteCart(false)
            .pipe(take(1))
            .subscribe(() => this.router.navigate(['/search-awb']));
    }
}
